import { Outlet } from "react-router-dom";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import useMediaVideo from "./useMediaVideo";


const MediaVideo = () => {
  const { drawerMenu } = useMediaVideo();

  return (
    <CommonLayout drawerMenu={drawerMenu}>
      <Outlet />
    </CommonLayout>
  );
};

export default MediaVideo;